module.exports = __webpack_public_path__ + "static/media/support-ticket-app.7bc0d807.png";